import { Application } from 'types/Application'
import { getApplicationName } from './getApplicationName'

const startsWithBrand = (app: Application) => (app.localizedDetails[0].name.startsWith('GoTo') ? 1 : 0)

export const sortGoToAppsFirst = (locale: string) => (a: Application, b: Application) =>
  startsWithBrand(b) - startsWithBrand(a) ||
  getApplicationName(a.localizedDetails, locale).localeCompare(getApplicationName(b.localizedDetails, locale))
